/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Referral } from './Referral';
import {
    ReferralFromJSON,
    ReferralFromJSONTyped,
    ReferralToJSON,
    ReferralToJSONTyped,
} from './Referral';

/**
 * 
 * @export
 * @interface ListReferralsByLead200Response
 */
export interface ListReferralsByLead200Response {
    /**
     * 
     * @type {Array<Referral>}
     * @memberof ListReferralsByLead200Response
     */
    items: Array<Referral>;
}

/**
 * Check if a given object implements the ListReferralsByLead200Response interface.
 */
export function instanceOfListReferralsByLead200Response(value: object): value is ListReferralsByLead200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ListReferralsByLead200ResponseFromJSON(json: any): ListReferralsByLead200Response {
    return ListReferralsByLead200ResponseFromJSONTyped(json, false);
}

export function ListReferralsByLead200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListReferralsByLead200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ReferralFromJSON)),
    };
}

export function ListReferralsByLead200ResponseToJSON(json: any): ListReferralsByLead200Response {
    return ListReferralsByLead200ResponseToJSONTyped(json, false);
}

export function ListReferralsByLead200ResponseToJSONTyped(value?: ListReferralsByLead200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ReferralToJSON)),
    };
}

